/**
 * WSL Notion is English only, like OVR and MSES: one locale,
 * `locales/en/*.json` behind typed `t()` keys, no picker. Its users are a
 * handful of super admins; GMS (apps/gms) is the app that keeps all ten.
 */

export const SUPPORTED_LOCALES = ["en"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en";

/** The locale handed to Intl.DateTimeFormat / Intl.NumberFormat. */
export function intlLocaleFor(_locale: string): string {
	return DEFAULT_LOCALE;
}
